// should-toggle-shortcuts.ts — PSTUDIO-3623. Pure predicate for ⌘/ (Ctrl+/):
// open/close the keyboard-shortcuts help panel. Evaluated in table.tsx's
// CAPTURE-phase keydown (like Shift+Enter for Expanded Cell View) so it can run
// closeOverlaySidePanels() for the "one sidebar panel at a time" rule. Both
// meta (Mac ⌘) and ctrl (Windows) are accepted; Shift excluded (⇧/ = "?").
export interface ToggleKeyState {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}
export interface ToggleCtx {
  isEditing: boolean;
  isInInput: boolean;
}
export function shouldToggleKeyboardShortcutsPanel(
  e: ToggleKeyState,
  ctx: ToggleCtx
): boolean {
  return (
    e.key === '/' &&
    (e.metaKey || e.ctrlKey) &&
    !e.shiftKey &&
    !e.altKey &&
    !ctx.isEditing &&
    !ctx.isInInput
  );
}
